/**
 * Describes the type of the delta being applied.
 */
export var TextTileDeltaType;
(function (TextTileDeltaType) {
    // Adds new content to the existing tile at the specified position
    TextTileDeltaType[TextTileDeltaType["Add"] = 0] = "Add";
    // Deletes content from the existing tile at the specified position
    TextTileDeltaType[TextTileDeltaType["Delete"] = 1] = "Delete";
    // Updates the content of the existing tile at the specified position
    TextTileDeltaType[TextTileDeltaType["Update"] = 2] = "Update";
})(TextTileDeltaType || (TextTileDeltaType = {}));
/**
 * The unit on which this delta is operating.
 */
export var TextTileDeltaUnit;
(function (TextTileDeltaUnit) {
    // Character level changes of no semantic meaning on their own.
    TextTileDeltaUnit[TextTileDeltaUnit["Chars"] = 0] = "Chars";
    // Adding/deleting/updating a single word.
    TextTileDeltaUnit[TextTileDeltaUnit["Word"] = 1] = "Word";
    // Adding/deleting/updating a part of a sentence.
    TextTileDeltaUnit[TextTileDeltaUnit["PartialSentence"] = 2] = "PartialSentence";
    // Adding/deleting/updating a full sentence.
    TextTileDeltaUnit[TextTileDeltaUnit["Sentence"] = 3] = "Sentence";
    // Adding/deleting/updating a full or partial paragraph.
    TextTileDeltaUnit[TextTileDeltaUnit["Paragraph"] = 4] = "Paragraph";
})(TextTileDeltaUnit || (TextTileDeltaUnit = {}));
//# sourceMappingURL=deltas.js.map